import React from 'react';
import * as StyledComponents from './StyledComponents';

const SkeletonEventRow: React.FC = () => {
  return (
    <React.Fragment>
      <h2>
        <StyledComponents.SkeletonText width="150px"/>
      </h2>
      <StyledComponents.EventGridWrapper>
        <StyledComponents.EventGrid>
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <StyledComponents.SkeletonCard key={i}>
              <StyledComponents.EventImageContainer>
                <StyledComponents.SkeletonImage />
              </StyledComponents.EventImageContainer>
              <StyledComponents.EventContent>
                <h2>
                  <StyledComponents.SkeletonText width="100%" />
                </h2>
                <StyledComponents.EventDetailContainer>
                  <StyledComponents.SkeletonText width="60%" />
                </StyledComponents.EventDetailContainer>
                <StyledComponents.EventDetailContainer>
                  <StyledComponents.SkeletonText width="40%" />
                </StyledComponents.EventDetailContainer>
              </StyledComponents.EventContent>
            </StyledComponents.SkeletonCard>
          ))}
        </StyledComponents.EventGrid>
      </StyledComponents.EventGridWrapper>
    </React.Fragment>
  );
};

export default SkeletonEventRow; 